import { useState } from 'react';
import {
  DeleteForever as TrashIcon,
  Search as SearchIcon,
} from '@mui/icons-material';

import { GlobalButton, SelectInput, TextInput } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { STORAGE_KEY } from '../../config';
import { TrackingIconFilter } from '../models';
import { useTrackingIconOptions } from '../hooks';

interface SearchBarProps {
  initialFilter: TrackingIconFilter;
  filter: TrackingIconFilter;
  search: (filters: TrackingIconFilter) => void;
}

const SearchBar = ({ initialFilter, filter, search }: SearchBarProps) => {
  const [localFilter, setLocalFilter] = useState(filter);
  const { enabledOptions, typeOptions } = useTrackingIconOptions();

  const saveFiltersToLocalStorage = (filters: TrackingIconFilter) => {
    localStorage.setItem(
      STORAGE_KEY.trackingIconsFilters,
      JSON.stringify(filters)
    );
  };

  const resetFilters = () => {
    setLocalFilter(initialFilter);
    saveFiltersToLocalStorage(initialFilter);
    search(initialFilter);
  };

  const handleSearch = () => {
    saveFiltersToLocalStorage(localFilter);
    search(localFilter);
  };

  return (
    <div className='w-full p-5 flex flex-col justify-center bg-white rounded-lg shadow-md gap-5'>
      <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
        <TextInput
          name='tracking-icon-name'
          placeholder='Nombre'
          value={localFilter.name}
          onChange={(value) =>
            setLocalFilter({ ...localFilter, name: value.toString() })
          }
        />
        <SelectInput
          name='tracking-icon-type'
          placeholder='Tipo'
          value={localFilter.isDefault || 'all'}
          options={typeOptions}
          onChange={(value) =>
            setLocalFilter({
              ...localFilter,
              isDefault: value === 'true' || value === 'false' ? value : '',
            })
          }
        />
        <SelectInput
          name='tracking-icon-enabled'
          placeholder='Habilitado'
          value={localFilter.enabled}
          options={enabledOptions}
          onChange={(value) =>
            setLocalFilter({
              ...localFilter,
              enabled: value.toString(),
            })
          }
        />
      </div>
      <div className='flex gap-2 justify-end'>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={resetFilters}
        >
          <TrashIcon color='primary' />
          Limpiar
        </GlobalButton>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={handleSearch}
        >
          <SearchIcon color='primary' />
          Buscar
        </GlobalButton>
      </div>
    </div>
  );
};

export default SearchBar;
